import React from 'react'
import styled from '@emotion/styled'

import SEO from '~/components/seo'
import Heading from '~/components/Heading'

import { breakpoints, Container } from '~/utils/styles'

const Terms = () => {
  return (
    <>
      <SEO title="Terms & Conditions" />
      <Padding>
        <Container>
          <div style={{ textAlign: 'center' }}>
            <Heading>Terms & Conditions</Heading>
          </div>
        </Container>
        <Container>
          <Content>
            <p>
              Nooro Ltd owns and operates the business which manufactures Nooro
              CBD Oat Bars.&nbsp;&nbsp;Nooro is incorporated under the laws of
              England and Wales, under Company No. 10261807 with its registered
              offices at 174 Hammersmith Road London&nbsp;W6 7JP.&nbsp;&nbsp;
            </p>
            <p>
              Nooro Ltd owns and operates this Website. This document governs
              your relationship with&nbsp;
              <a href="https://getnooro.com/">https://getnooro.com/</a>{' '}
              &nbsp;(“website”). The contents of this Website and all related IP
              are owned by Nooro Ltd.
            </p>
            <p>
              The statements and references to CBD products found throughout our
              site have not been evaluated by the FSA (Food Standards Agency).
            </p>
            <p className="highlight">
              Our CBD products should not be used as a substitute for a varied
              diet and healthy balanced lifestyle. The products are sold as
              dietary and nutritional supplements and not intended to prevent,
              treat or cure any disease.
            </p>
            <p>
              Nooro Ltd does not sell or distribute, any products that are in
              violation of the United Kingdom Misuse of Drugs Act 1971. Nooro
              Ltd does not advertise the product towards markets where the
              product is illegal or by other means does not encourage customers
              to incriminate oneself. It is the responsibility of the customer
              to ensure that they are in compliance with local legislation.
            </p>
            <p>
              Do not take if pregnant or lactating. Keep away from children.
              Always consult with your health care provider before making any
              medical decisions.
            </p>
            <h2>Age Restrictions</h2>

            <p>
              You must be 18 years or older to purchase and use the products
              from the website.&nbsp;
            </p>
            <h2>Shipping and Delivery</h2>
            <p>
              After an order has been received in our system, 48 hours is
              required to review and dispatch the order (this does not include
              any potential for inclement weather, holidays, or backorders). We
              receive orders from Monday to Friday. We will endeavour to
              complete the delivery by the next working day if we receive your
              order before midday.
            </p>
            <p>
              <strong>
                We’re sorry if there was a problem with your order, please
                contact us via&nbsp;
                <a
                  href="mailto:hello@getnooro.com"
                  aria-describedby="a11y-external-message"
                >
                  hello@getnooro.com
                </a>
              </strong>
              .
            </p>
            <p>
              If you have ordered your purchase for delivery at home we should
              deliver it to you within 14 days – unless you specifically agreed
              on a different delivery time. If you don’t receive your goods
              within 14 days, or within the agreed time, you should remind us,
              giving an additional, reasonable time limit to deliver.
            </p>
            <p>
              You must always be clearly informed of the total price for your
              purchase, including delivery and other related costs. You must
              give your explicit consent to any additional costs. Terms of
              purchase have to be accepted before purchase.
            </p>
            <h2>Returns and Refunds</h2>
            <p>
              Once an order has been dispatched you may return the goods within
              30 days of receipt. Goods must be unopened with seals intact.
              Please ensure that the item you are returning is repackaged with
              all elements in its original condition. If an item has been
              used/opened we cannot accept a return due to potential denaturing
              of the product.
            </p>
            <p>
              To cancel or return goods please contact us via&nbsp;
              <a
                href="mailto:hello@getnooro.com"
                aria-describedby="a11y-external-message"
              >
                hello@getnooro.com
              </a>
              &nbsp;quoting your order number. Only items that have been
              purchased directly from us can be returned.
            </p>
            <p>
              If for any reason you are unhappy with your purchase, simply
              return it to us in its original condition within 7 days from
              delivery and we’ll exchange the item or refund the purchase price
              to you. You can also ask for a price reduction or a refund.
            </p>
            <p>
              <strong>
                There is a 2 year-guarantee for all goods free of charge under
                the EU law
              </strong>
              .
            </p>
            <p>When returning the right inquiry and complaints are sent to:</p>
            <p>Nooro Ltd, 174 Hammersmith Road W6 7JP</p>
            <h2>Intellectual Property, Software and Content</h2>
            <p>
              All content included on the&nbsp;
              <a href="https://getnooro.com/">https://getnooro.com/</a>
              &nbsp;including, but not limited to, text, graphics, logos, icons,
              images, sound clips, video clips, data compilations, page layout,
              underlying code and software is the property of{' '}
              <a href="https://getnooro.com/">https://getnooro.com/</a>, our
              affiliates or other relevant third parties.
            </p>
            <p>
              By continuing to use the website you acknowledge that such
              material is protected by applicable England and international
              intellectual property and other laws. You may not reproduce, copy,
              distribute, store material from the website unless otherwise
              indicated on the website or unless given our express written
              permission to do so.
            </p>
            <h2>Links to other websites</h2>
            <p>
              This Website may contain links to other sites. Unless stated,
              these sites are not under the control of Nooro Ltd. The inclusion
              of a link to another site on this Website does not imply any
              endorsement of the sites themselves or of those in control of
              them. We assume no responsibility for the content of such
              websites.
            </p>
            <h2>Terms of Sale</h2>
            <p>
              By placing an order you are offering to purchase a product on and
              subject to the following terms and conditions. All orders are
              subject to availability and confirmation of the order price.
              Dispatch times may vary according to availability and subject to
              any delays resulting from postal delays or force majeure for which
              we will not be responsible. In order to contract with&nbsp;
              <a href="https://getnooro.com/">https://getnooro.com/</a>
              &nbsp;you must possess a valid credit or debit card issued by a
              bank acceptable to us.&nbsp;
              <a href="https://getnooro.com/">https://getnooro.com/</a>
              &nbsp;retains the right to refuse any request made by you. If your
              order is accepted we will inform you by email and we will confirm
              the identity of the party which you have contracted with. This
              will usually be&nbsp;
              <a href="https://getnooro.com/">https://getnooro.com/</a>
              &nbsp;or may in some cases be a third party. Where a contract is
              made with a third party&nbsp;
              <a href="https://getnooro.com/">https://getnooro.com/</a>
              &nbsp;is not acting as either agent or principal and the contract
              is made between yourself and that third party and will be subject
              to the terms of sale which they supply you.&nbsp;When placing an
              order you undertake that all details you provide to us are true
              and accurate, that you are over 18 and an authorised user of the
              credit or debit card used to place your order and that there are
              sufficient funds to cover the cost of the goods. Nooro Ltd
              receives payment with VISA, VISA Electron, Mastercard, American
              Express. All amounts are in British Pounds. The money will first
              be deducted from your card after the goods are shipped. All prices
              advertised are subject to changes. Terms need to be accepted
              before the purchase. We cannot accept responsibility for any
              repercussions or replace any confiscations for any products
              purchased through this site being delivered outside of the
              applicable laws of our country. Responsibility is held by you, the
              customer, &amp; all laws respective of your country have been
              obeyed. &nbsp;
            </p>
            <h2>Our Contract</h2>
            <p>
              When you place an order, you will receive an acknowledgement email
              confirming receipt of your order: this email will only be an
              acknowledgement and will not constitute acceptance of your order.
              A contract between us will not be formed until we send you
              confirmation by e-mail that the goods which you ordered have been
              dispatched to you. Only those goods listed in the confirmation
              email sent at the time of dispatch will be included in the
              contract formed.
            </p>
            <h2>Privacy</h2>
            <p>
              Any details which you provide to us from which we can identify you
              are held and processed lawfully and in accordance with the Data
              Protection Act 1998. Our privacy policy, which sets out how we
              will use your information, can be found&nbsp;
              <a href="https://getnooro.com/pages/privacy-policy/">here</a>. By
              using this website, you consent to the processing described there
              and warrant that all data provided by you is accurate. Any
              questions regarding our privacy policy should be addressed to the
              attention of Nooro Ltd by email at&nbsp;
              <a
                href="mailto:hello@getnooro.com"
                aria-describedby="a11y-external-message"
              >
                hello@getnooro.com
              </a>
              .
            </p>
            <h2>Security</h2>
            <p>
              Nooro Ltd uses secure server software (SSL) to ensure your credit
              card will be protected against fraudulent use while on our
              website. This means that no one can read your information.
            </p>
            <h2>Changes in the Terms and Conditions</h2>
            <p>
              By using our website, you consent to the collection and use of the
              information you provide to us as outlined in the Terms and
              Conditions. We may change them from time to time and without
              notice, so make sure you check back occasionally. If we change our
              Terms and Conditions, we will publish those changes right here on
              this page. If you have any questions or concerns about our terms
              and conditions, use or disclosure of your personal information,
              please send us an email.
            </p>
            <h2>Variation</h2>
            <p>
              <a href="https://getnooro.com/">https://getnooro.com/</a>
              &nbsp;shall have the right in its absolute discretion at any time
              and without notice to amend, remove or vary the Services and/or
              any page of this Website.
            </p>
            <h2>Waiver</h2>
            <p>
              If you breach these conditions and we take no action, we will
              still be entitled to use our rights and remedies in any other
              situation where you breach these conditions.
            </p>
            <h2>Governing Law</h2>
            <p>
              These Terms and conditions are governed by the laws of England and
              Wales. The courts of England and Wales have jurisdiction in
              respect of any disputes arising under these Terms and conditions.
            </p>
            <h2>Entire Agreement</h2>
            <p>
              The above Terms of Service constitute the entire agreement of the
              parties and supersede any and all preceding and contemporaneous
              agreements between you and&nbsp;
              <a href="https://getnooro.com/">https://getnooro.com/</a>. Any
              waiver of any provision of the Terms of Service will be effective
              only if in writing and signed by a Director of&nbsp;
              <a href="https://getnooro.com/">https://getnooro.com/</a>.
            </p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
          </Content>
        </Container>
      </Padding>
    </>
  )
}

export default Terms

const Padding = styled.div`
  padding-top: 192px;

  @media (max-width: ${breakpoints.s}px) {
    padding-top: 150px !important;
  }
`

const Content = styled.div`
  max-width: 840px;
  font-size: 18px;
  margin: 50px auto 100px;

  a {
    color: #d16643;
  }

  .highlight {
    font-family: 'SohneBreit';
  }

  h2 {
    font-family: 'SohneBreit';
    letter-spacing: 1px;
  }

  @media (max-width: ${breakpoints.s}px) {
    padding: 0 20px;
    font-size: 16px;
    margin: 30px auto 60px;

    h2 {
      font-size: 20px;
    }
  }
`
